import React, { FC, useEffect, useState } from 'react'
import logo from '../../../Assets/images/logo.png'
import psc from '../../../Assets/images/psc1_logo.png'
import { useAuth } from '../../../Components/AuthProvider/AuthProvider'
import { useNavigate } from 'react-router'
import { useLoggedInUser } from '../../../Hooks'
import toast from 'react-hot-toast'
import './Navbar.scss'

const Navbar: FC = () => {
  const { logout, user } = useAuth()
  const [showUserMenu, setShowUserMenu] = useState(false)
  const [userRole, setUserRole] = useState<string | null>(null)
  const navigate = useNavigate()

  const logOut = () => {
    logout()
    navigate('/login', { replace: true })
  }

  useEffect(() => {
    const loggedInUser = useLoggedInUser()
    if (loggedInUser !== null) {
      const exp = loggedInUser.exp
      const currentTime = new Date()
      const convertTime = new Date(exp * 1000)

      if (convertTime <= currentTime) {
        logout()
        toast.error('Session timed out', { duration: 3000 })
        navigate('/login', { replace: true })
      }

      setUserRole(loggedInUser.mainRole)
    }
  }, [logout, navigate])

  return (
    <nav className="modern-navbar">
      <div className="navbar-container">
        {/* Left Section */}
        <div className="navbar-left">
          {/* Mobile Toggle */}
          <button className="sidebar-toggle mobile-only">
            <i className="fa fa-bars"></i>
          </button>

          {/* Logo */}
          <a href="/dashboard" className="navbar-brand">
            <img
              src={userRole === 'pscreen_academic_officer' ? psc : logo}
              alt="Logo"
              className="brand-logo"
            />
          </a>

          {/* Desktop Toggle */}
          <button className="sidebar-toggle desktop-only">
            <i className="fa fa-bars"></i>
          </button>

          {/* All Applicants Link */}
          <div className="job-selector">
            <i className="fa fa-users job-icon"></i>
            <a href="/applicants" className="applicants-link">
              All Applicants
            </a>
          </div>
        </div>

        {/* Right Section */}
        <div className="navbar-right">
          {/* Notifications */}
          <div className="navbar-action">
            <button className="action-button">
              <i className="fa fa-bell"></i>
              <span className="notification-badge">0</span>
            </button>
          </div>

          {/* Messages */}
          <div className="navbar-action">
            <button className="action-button">
              <i className="fa fa-envelope-open"></i>
              <span className="notification-badge">0</span>
            </button>
          </div>

          {/* User Menu */}
          <div className="user-menu">
            <button
              className="user-button"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="user-avatar">
                <i className="fa fa-user"></i>
              </div>
              <div className="user-info">
                <span className="user-name">
                  {user?.firstname} {user?.lastname}
                </span>
              </div>
              <i className={`fa fa-chevron-${showUserMenu ? 'up' : 'down'} user-chevron`}></i>
            </button>

            {showUserMenu && (
              <div className="user-dropdown">
                <div className="dropdown-header">Account</div>
                <a href="/settings" className="dropdown-item">
                  Settings
                </a>
                <div className="dropdown-divider"></div>
                <button onClick={logOut} className="dropdown-item logout">
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
